var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.imageUrl,"max-height":_vm.smallSize ? 72 : 300,"max-width":_vm.smallSize ? 65 : 400,"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }